import React from 'react';
import {
    MediaTeaser as MediaTeaserShared,
    openInNewWindow,
    useAnalyticsActionTracker,
} from '@cp-shared-10/frontend-ui';
import { LandingPageMarketingCard } from 'common';
import { ContentSection, Layout, PageWrap } from '@vwfs-bronson/bronson-react';

export const LandingPageMarketingCardsUi: React.FC<{ landingPageMarketingCards?: LandingPageMarketingCard[] }> = ({
    landingPageMarketingCards: cards,
}) => {
    const { onAction } = useAnalyticsActionTracker('onClickMarketingCard');

    if (!cards) {
        return null;
    }

    return (
        <ContentSection>
            <PageWrap size={'medium'}>
                <Layout>
                    {cards.map(({ title, imageUrl, pretitle, text, buttonLabel, buttonUrl }, index) => (
                        <Layout.Item key={index}>
                            <MediaTeaserShared
                                title={title || ''}
                                imageUrl={imageUrl || ''}
                                pretitle={pretitle || ''}
                                text={<div dangerouslySetInnerHTML={{ __html: text || '' }} />}
                                buttonLabel={buttonLabel}
                                clickHandler={(e) => {
                                    onAction(title);
                                    openInNewWindow(buttonUrl)(e);
                                }}
                                reversed={index % 2 === 1}
                            />
                        </Layout.Item>
                    ))}
                </Layout>
            </PageWrap>
        </ContentSection>
    );
};
